import { ToastContainer } from "react-toastify";
import SignUpForm from "../../components/SignUpForm";
import React from "react";
// import { ToastContainer } from "react-toastify";
// import "react-toastify/dist/ReactToastify.css";

export const metadata = {
  title: "Avcon | Signup",
  description: "dynamic form",
};

function Signup() {
  return (
    <div className="h-screen ">
      <ToastContainer />
      {/* <img src="/YouHueBG.png" className="w-full h-full" /> */}
      <SignUpForm />
    </div>
  );
}

export default Signup;
